import React from "react";
import styles from "../styles.module.scss";
import { camelCase } from "lodash";
import { useTranslation } from "react-i18next";

const ReportTotals = ({ totals, columns, loading }) => {
  const { t } = useTranslation();

    if (loading) {
        return null;
    }

    if (!totals || totals.length === 0) {
        return null;
    }

    const translateColumn = (total: any, column: string) => {
      let words;

      if (['studentHandle', 'programHours', 'lessonHours', 'duration', 'programTitle'].includes(column) && total) {
        words = total.toString().split(' ');
        words = words.map((word: any) => t(word, { nsSeparator: false }));

        return words.join(' ');
      } else {
        return total;
      }
    };

    return (
      <tr className={styles.row}>
        {columns.map((c) => (
          <td className={styles.column} key={c.fieldName}>
            {translateColumn(totals[camelCase(c.fieldName)], camelCase(c.fieldName))}
          </td>
        ))}
      </tr>
    );
};

export default ReportTotals;
